const csv = (value: string | undefined, fallback: string): string[] =>
  (value ?? fallback)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

export const env = Object.freeze({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000/api/v1',
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT ?? 15000),
  appName: import.meta.env.VITE_APP_NAME ?? 'ZeroGhostShield',
  appTagline: import.meta.env.VITE_APP_TAGLINE ?? 'Your Identity. Invisible.',
  aliasDomains: csv(
    import.meta.env.VITE_ALIAS_DOMAINS,
    'zeroghostshield.com,ghostmask.net,shieldmail.io',
  ),
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '',
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
});
